<div class="custom-slider">
  <ngx-slider
    [(value)]="value"
    [(highValue)]="highValue"
    [options]="options"
    (valueChange)="changeValue()"
    (highValueChange)="changeValue()"
  ></ngx-slider>
</div>
